import API from "../configs/axiosInstance";

const fetchByDomain = (data) => {
  return API({
    url: `account-service/v1/news/fetch-by-domain`,
    method: "POST",
    data
  });
};

const getThreatIntelNews = (title) => {
  return API({
    url: `account-service/v1/threat-intels/all`,
    method: "POST",
    data: {
      title,
    },
  })
}

const getDomainNews = () => {
  return API({
    url: `account-service/v1/news/selected-domains-news`,
    method: "GET",
  });
}

const getDomainNewsDetails = (data, params = {}) => {
  return API({
    url: `account-service/v1/news/${data?.domainId}/domain-news-detail?title=${data?.title || ''}`,
    method: "GET",
    params
  });
}

export default {
  getDomainNews,
  getDomainNewsDetails,
  fetchByDomain,
  getThreatIntelNews
};
